import { render } from "./DeliveryRow.vue?vue&type=template&id=149e1ca1&scoped=true"
import script from "./DeliveryRow.vue?vue&type=script&lang=js"
export * from "./DeliveryRow.vue?vue&type=script&lang=js"

import "./DeliveryRow.vue?vue&type=style&index=0&id=149e1ca1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149e1ca1"]])

export default __exports__